<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Representative Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="representativeForm" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label class="required" title="* Required">First Name</label>
                    <input id="firstName" class="mvd_form-control" type="text" maxlength="50" formControlName="firstName" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.get('firstName').hasError('required') && isSubmitted">Required</div>
                    </div>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Last Name</label>
                    <input id="lastName" class="mvd_form-control" type="text" maxlength="50" formControlName="lastName" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.get('lastName').hasError('required') && isSubmitted">Required</div>
                    </div>
                </div>
                <div class="col-sm-1 mvd_form-group" *ngIf="customerRepresentativeId != 0">
                    <label>&nbsp;</label>
                    <a class="icon--delete" href="javascript:void(0)" title="Delete" (click)="deleteCustomerRepresentative()"></a>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Phone</label>
                    <p-inputMask mask="(999) 999-9999" formControlName="cellPhone"></p-inputMask>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.get('cellPhone').hasError('required') && isSubmitted">Required</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Effective Date</label>
                    <p-calendar [showIcon]="true" dateFormat="mm/dd/yy" formControlName="effectiveDate"></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.get('effectiveDate').hasError('required') && isSubmitted">Required</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label class="required" title="* Required">Email</label>
                    <input id="email" class="mvd_form-control" type="text" formControlName="email" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.get('email').hasError('required') && isSubmitted">Required</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label title="DriverLicenseNumber">DL#</label>
                    <input id="driverLicenseNumber" class="mvd_form-control" type="text" maxlength="20" formControlName="driverLicenseNumber" />
                </div>
            </div>
            <div class="divider"></div>
            <h2>AZ MVD Now Login Details</h2>
            <div class="row">
                <div class="col-sm-8 mvd_form-group">
                    <label class="mvd_label--inline"><input id="organizationAdministrator" class="mvd_form-control" type="checkbox" formControlName="organizationAdministrator" />&nbsp;Organization Administrator</label>
                </div>
            </div>
            <div class="row" *ngIf="!customerRepresentative.id">
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{'required': customerRepresentativeId == 0}" [attr.title]="(customerRepresentativeId == 0) ? ' * Required' : null">Password</label>
                    <input id="mvdNowPassword" class="mvd_form-control" type="password" maxlength="50" formControlName="mvdNowPassword" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.hasError('required') && isSubmitted">Required</div>
                        <div class="mvd_alert__rule" *ngIf="representativeForm.controls.mvdNowPassword.touched && (representativeForm.controls.mvdNowPassword.hasError('minlength') || representativeForm.controls.mvdNowPassword.hasError('maxlength'))">
                            Password must be between {{passwordMinLength}} and {{passwordMaxLength}} characters
                        </div>
                        <div class="mvd_alert__rule" *ngIf="representativeForm.controls.mvdNowPassword.touched && representativeForm.controls.mvdNowPassword.hasError('passwordRequiresMoreCharacterClasses') && !representativeForm.controls.mvdNowPassword.hasError('minlength') && !representativeForm.controls.mvdNowPassword.hasError('maxlength')">
                            Password must contain at least {{characterClassMinCount}} of the following: a lowercase letter, an uppercase letter, a number, and a symbol
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{'required': customerRepresentativeId == 0}" [attr.title]="(customerRepresentativeId == 0) ? ' * Required' : null">Confirm Password</label>
                    <input id="confirmMVDNowPassword" class="mvd_form-control" type="password" maxlength="50" formControlName="confirmMVDNowPassword" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="representativeForm.controls.confirmMVDNowPassword.touched && representativeForm.hasError('passwordMatch')">Password does not match</div>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(representativeForm.valid && representativeForm.dirty)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="onSaveClick()"></mvm-spinner-btn>
    </div>
</div>
